import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import PageHeaderDialogs from '../../../enums/PageHeaderDialogs';
import useWindowResize from '../../../hooks/useWindowSize';
import { ClientBusinessLine } from '../../../sic-lib/enums/ClientBusinessLine';
import { useAppSelector } from '../../../store/hooks';
import DialogCreateContact from '../../Contact/DialogCreateContact/DialogCreateContact';
import { UserAvatarPopoverContainer } from '../../Settings/Users/UserAvatarPopoverContainer';
import MenuPageHeaderActions from '../MenuPageHeaderActions/MenuPageHeaderActions';
import PageHeaderActions from './PageHeaderActions/PageHeaderActions';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.appHeader.main,
        //height: '3.6rem'
    },
    heading: {
        textTransform: 'capitalize',
        color: theme.palette.appHeader.contrastText,
    },
}));

interface Props {
    title: string;
}

export default function PageHeader({ title }: Props) {
    const { classes, cx } = useStyles();

    const user = useAppSelector(state =>
        state.user.users.find(user => user.userName === state.user.userName),
    );
    const businessLine = useAppSelector(state => state.user.businessLine);

    const { hasLargeScreen, hasMediumScreen } = useWindowResize();

    const [dialog, setDialog] = React.useState<string | null>(null);

    const handleOpenDialog = (event: React.MouseEvent<HTMLElement>) => {
        /*
                TIP: Use data-name attribute on buttons and MuiMenuItems to pass selected dialog name:
                name, event typeof HTMLButtonElement are not recognized/ assignable to MuiMenuItems 
                and 'name' attribute does not exist on event typeof HTMLElement.
             */
        const { name } = event.currentTarget.dataset;

        if (name) {
            setDialog(name);
        }
    };

    const handleCloseDialog = () => {
        setDialog(null);
    };

    return (
        <React.Fragment>
            <Grid
                container
                item
                alignItems="center"
                justifyContent="space-between"
                columnSpacing={2}
                className={cx(
                    classes.root,
                    businessLine === ClientBusinessLine.proctor && 'bgImage--bricks',
                    'pageMain__header__wrap',
                )}
            >
                <Grid item xs="auto">
                    <Typography component="h1" variant="h5" className={classes.heading}>
                        {title}
                    </Typography>
                </Grid>
                <Grid item container spacing={2} xs="auto" alignItems="center" mr={1}>
                    <Grid item xs={true}>
                        {hasLargeScreen || hasMediumScreen ? (
                            <PageHeaderActions onOpenDialogHandler={handleOpenDialog} />
                        ) : (
                            <MenuPageHeaderActions onOpenDialogHandler={handleOpenDialog} />
                        )}
                    </Grid>
                    <Grid item>
                        <UserAvatarPopoverContainer user={user} />
                    </Grid>
                </Grid>
            </Grid>
            {
                /*
                    TIP: dialogs do not unmount when closed(?) persevering state: force
                    an unmount with conditional rendering

                    TIP: add dialogs to this component and pass opening functions to PageHeaderActions
                    components to reduce the amount of repetitive code.
                */
                dialog === PageHeaderDialogs.createContact && (
                    <DialogCreateContact
                        isOpen={dialog === PageHeaderDialogs.createContact}
                        onCloseHandler={handleCloseDialog}
                    />
                )
            }
        </React.Fragment>
    );
}
